import { useCallback, useEffect, useState } from "react";
import { MessagesSquare } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { Page, PageHead } from "@/components/hub/Common";
import { TicketForm } from "@/components/hub/TicketForm";
import { TicketList } from "@/components/hub/TicketList";
import { TicketThread } from "@/components/hub/TicketThread";

export default function Support() {
  const { t } = useI18n();
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [active, setActive] = useState(null);
  const load = useCallback(() => api.get("/support/tickets").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const pick = (id) => { setActive(id); setTimeout(load, 400); };
  return (
    <Page>
      <PageHead label={t("sup.label")} t1={t("sup.title1")} t2={t("sup.title2")} sub={t("sup.sub")} />
      <div className="grid xl:grid-cols-[400px_1fr] gap-6 mt-10 items-start">
        <div className="space-y-6">
          {user?.role === "demo" ? <div className="cx-card rounded-2xl p-6 text-sm text-slate-400" data-testid="ticket-demo-note">{t("sug.demo")}</div>
            : <TicketForm onCreated={(id) => { load(); setActive(id); }} />}
          <div>
            <div className="cx-label mb-3">{t("sup.mine")}</div>
            <TicketList list={list} active={active} onPick={pick} />
          </div>
        </div>
        {active ? <TicketThread key={active} id={active} onChange={load} /> : (
          <div className="cx-card rounded-2xl min-h-[420px] grid place-items-center text-center p-8" data-testid="ticket-placeholder">
            <div><MessagesSquare className="w-10 h-10 text-[#2f7bff] mx-auto" /><p className="text-sm text-slate-500 mt-4">{t("sup.pick")}</p></div>
          </div>
        )}
      </div>
    </Page>
  );
}
